/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PaperClockIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABSklEQVR4nN2VvU7DQAzHIwYkJMTCU7BWLCDYK8jZznC1I8SzZKgqhTfhJUp5FJaCVCY+xEaLHBopJNckvYQBLHmJdf7Z/vtyQfBvzFq7C8Q3BvkRSFY+bojnQJJqrgpAA76JoeppBdClcig7ypOrg1WfHtQBEPnUpVNI8VkvAE3kAiDyeS+AXx8R/HkAbhC5zvQMEL+scyy9RG4ya+1eSPEJYnxRCW7TvkH5ILo+bCR6A0hu83OGGAH5Hojf1Q3JDDE2/gDkh+Hw6qDF/2vSSWSjlZfOlG+6IQ69RYZsLNW1LI3ybssR8XOSJDtZByhvTgDKogB4LbY8bwOx1u67AAByrN/DaDRwAto+OGE0GnwXJLOf4stCY0R8ZJA/1wsxLT2ZkjZ0sswvka5iY0GRXDZpWS80yWTzZeRxp+S56SrqtqgmmS7I02LlX29tls6NEK4pAAAAAElFTkSuQmCC)
 */
export const PaperClockIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M5 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h6.88c.37 0 .61-.38.5-.73a7 7 0 0 1-.37-2.7.53.53 0 0 0-.52-.57H6a1 1 0 1 1 0-2h6.36c.2 0 .37-.11.46-.28.3-.6.7-1.13 1.17-1.6.35-.37.11-1.12-.4-1.12H6a1 1 0 1 1 0-2h12a1 1 0 0 1 .88.52c.13.24.34.48.62.5.61.04 1.2.16 1.77.36.35.11.73-.13.73-.5V5a3 3 0 0 0-3-3H5Zm1 4a1 1 0 0 0 0 2h5a1 1 0 1 0 0-2H6Z"
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        d="M24 19a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm-5-3a1 1 0 0 1 1 1v1.59l.7.7a1 1 0 1 1-1.4 1.42l-1-1A1 1 0 0 1 18 19v-2a1 1 0 0 1 1-1Z"
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
